import React, { useState, useEffect } from 'react';
import { View, Text, Dimensions, StyleSheet, Linking, TouchableOpacity, Modal } from 'react-native';
import { SIZES, FONTS, COLORS } from '../constants';
import { MaterialIcons } from '@expo/vector-icons';
import { OutlineBtn, SolidBtn, LightboxView } from "./"

const ModalPopup = ({ visible, children }) => {
  const [showModal, setShowModal] = useState(visible);

  const toggleModal = () => {
    if (visible) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }

  useEffect(() => {
    toggleModal()
  }, [visible])

  return (
    <Modal transparent visible={showModal}>
      <View style={styles.modalBackground}>
        <View style={styles.modalContainer}>
          {children}
        </View>
      </View>
    </Modal>
  )
};

export default function OutlineBtnHeader(props) {

  const [visible, setVisible] = useState(false);
  // const source = { uri: 'http://samples.leanpub.com/thereactnativebook-sample.pdf', cache: true };
  const source={ uri: 'http://knittingisawesome.com/wp-content/uploads/2012/12/cat-wearing-a-reindeer-hat1.jpg' }
  const dziennikUstaw = require( "../img/durp_poz2331.png")


  return (
    <>
      <TouchableOpacity
        style={styles.headerRight}
        // onPress={() => alert('This is a button!')}
        // onPress={() => ustawaAlert()}
        onPress={() => setVisible(true)}
      >
        <View style={styles.headerBtn}>
          {/* <MaterialIcons name="arrow-forward" size={48} color={COLORS.primary} /> */}
          <Text style={styles.rightText}>
            {props.text}
          </Text>
        </View>
      </TouchableOpacity>

      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ModalPopup visible={visible}>
          <View style={{ alignItems: 'center' }}>
            <View style={styles.header}>
              <TouchableOpacity
                onPress={() => setVisible(false)}
              >
                <MaterialIcons name="close" size={24} color="black" />
              </TouchableOpacity>
            </View>
            <Text style={{ marginVertical: 10, fontSize: 12, textAlign: 'center' }}>
              ROZPORZĄDZENIE {'\n'}MINISTRA OBRONY NARODOWEJ {'\n'}
              z dnia 2 grudnia 2020 r. {'\n'}w sprawie {'\n'}
              przeprowadzania sprawdzianu sprawności fizycznej żołnierzy zawodowych. {'\n\n'} Dz.U. 2020 poz. 2331
            </Text>
            <OutlineBtn
              text="isap.sejm.gov.pl"
              iconName="picture-as-pdf"
              iconSize={24}
              iconColor={COLORS.primary}
              onPress={() => { Linking.openURL('https://isap.sejm.gov.pl/isap.nsf/download.xsp/WDU20200002331/O/D20202331.pdf') }}
            />
          </View>
          <LightboxView src={dziennikUstaw}/>
        </ModalPopup>
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  headerRight: {
    padding: 15,
    margin: 10,
  },
  headerBtn: {
    backgroundColor: COLORS.background,
    borderColor: COLORS.secondary,
    borderRadius: 5,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: 70,
    height: 30,
  },
  rightText: {
    color: COLORS.primary,
    fontSize: 10
  },
  modalBackground: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContainer: {
    width: '90%',
    backgroundColor: COLORS.primary,
    paddingHorizontal: 20,
    paddingVertical: 20,
    borderRadius: 20,
    elevation: 20
  },
  header: {
    width: '100%',
    height: 40,
    alignItems: 'flex-end',
    justifyContent: 'center'
  }
})